import React, { useState } from 'react'
import { Button } from '../../ui'
import { SORT_FIELDS } from './utils/sorting.js'

const SORT_LABELS = {
  dueDate: 'due date',
  priority: 'priority',
  status: 'status',
  assignee: 'assignee',
  age: 'age',
}

function isOverdue(task, now) {
  if (!task.dueDate) return false
  if (task.status !== 'TODO' && task.status !== 'IN_PROGRESS') return false
  const [y, m, d] = task.dueDate.split('-').map(Number)
  const due = new Date(y, (m ?? 1) - 1, d ?? 1)
  return due < now
}

function isOpen(task) {
  return task.status === 'TODO' || task.status === 'IN_PROGRESS'
}

export function TaskListHeader({
  tasks,
  sortField,
  sortDirection,
  onSortFieldChange,
  onSortDirectionToggle,
  errorMessage,
  onCreateClicked,
}) {
  const [menuOpen, setMenuOpen] = useState(false)
  const startOfDay = new Date()
  startOfDay.setHours(0, 0, 0, 0)

  const openCount = tasks.filter(isOpen).length
  const overdueCount = tasks.filter((t) => isOverdue(t, startOfDay)).length

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 4px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
          <h3 style={{ margin: 0, fontSize: 12, fontWeight: 600, color: 'var(--text-primary)' }}>
            Tasks
          </h3>
          <span style={{ fontSize: 11, color: 'var(--text-secondary, #888)' }}>
            {openCount} open
          </span>
          {overdueCount > 0 && (
            <span style={{ fontSize: 11, color: '#c45a5a', fontWeight: 600 }}>
              · {overdueCount} overdue
            </span>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {onCreateClicked && (
            <Button size="sm" variant="secondary" onClick={onCreateClicked}>
              + add task
            </Button>
          )}
          <div style={{ position: 'relative' }}>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-haspopup="menu"
              aria-expanded={menuOpen}
              style={{
                fontSize: 11,
                padding: '2px 8px',
                borderRadius: 6,
                border: '1px solid var(--border, #e8e8e6)',
                background: 'transparent',
                color: 'var(--text-secondary, #666)',
                cursor: 'pointer',
              }}
            >
              Sort: {SORT_LABELS[sortField] ?? sortField}{' '}
              <span
                onClick={(e) => {
                  e.stopPropagation()
                  setMenuOpen(false)
                  onSortDirectionToggle()
                }}
                aria-label={`Sort direction: ${sortDirection}. Click to toggle.`}
                role="button"
                tabIndex={-1}
                style={{ marginLeft: 4 }}
              >
                {sortDirection === 'asc' ? '↑' : '↓'}
              </span>
            </button>
            {menuOpen && (
              <div
                role="menu"
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 'calc(100% + 4px)',
                  background: 'white',
                  border: '1px solid var(--border, #e8e8e6)',
                  borderRadius: 6,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  zIndex: 10,
                  minWidth: 140,
                }}
              >
                {SORT_FIELDS.map((field) => (
                  <button
                    key={field}
                    type="button"
                    role="menuitem"
                    onClick={() => {
                      onSortFieldChange(field)
                      setMenuOpen(false)
                    }}
                    style={{
                      display: 'block',
                      width: '100%',
                      textAlign: 'left',
                      padding: '6px 10px',
                      background: field === sortField ? '#f4f4f4' : 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: 11,
                      color: 'var(--text-primary)',
                    }}
                  >
                    {SORT_LABELS[field]}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {errorMessage && (
        <div
          role="status"
          style={{
            fontSize: 11,
            color: '#c45a5a',
            padding: '2px 4px',
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  )
}
